// extracted by mini-css-extract-plugin
export default {"termsOfConditionsContainer":"Terms_termsOfConditionsContainer__humG1","tutorialLink":"Terms_tutorialLink__tVsjU"};